export default {"src":"/_next/static/media/plane_64.1def097d.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};